import { render, staticRenderFns } from "./PanelGrid.vue?vue&type=template&id=18898020&"
import script from "./PanelGrid.vue?vue&type=script&lang=js&"
export * from "./PanelGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports